import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import './assets/styles/global.scss'
import './assets/styles/mobile.scss'

// 初始化错误监控
import errorMonitor from './utils/errorMonitor'

const app = createApp(App)

app.use(store)
app.use(router)
app.use(ElementPlus)

// 全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue应用错误:', err)
  errorMonitor.recordError(err, info)
}

app.mount('#app')
